import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';
import { DashboardContent } from 'src/layouts/dashboard';
import { PlateMembers } from 'src/sections/home/plate-members';

// ----------------------------------------------------------------------

const metadata = { title: `Plate Members |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>
      <DashboardContent>
        <PlateMembers />
      </DashboardContent>
    </>
  );
}
